<template>
    <div>
        <el-carousel :interval="5000" indicator-position="none" height="5.26rem">
            <el-carousel-item v-for="(item, index) in data_list.sylb_sjd_tp" :key="index">
                <img :src="item.format_img" style="width: 100%; height: 100%;" alt="" @click="openweb(item.image_url)">
            </el-carousel-item>
        </el-carousel>

        <div style="padding: 0 0.3rem; height: 11.8rem;" ref="dom1">
            <transition name="el-zoom-in-center">
                <div v-show="dom1_show">
                    <div style="margin-top: 0.3rem;" class="tc">
                        <b style="font-size: 0.48rem;">关于我们</b>
                    </div>
                    <p style="font-size: 0.32rem; margin: 0.1rem auto 0 auto; line-height: 0.5rem; letter-spacing: 1px;" class="tc">{{data_list.gywm_js}}</p>

                    <div class="flx" ref="init" style="width: 9.4rem; overflow-x: hidden; margin-top: 0.2rem;" v-show="dom1_show">
                        <div ref="m1" class="flx">
                            <div style="margin: 0 0.2rem;" v-for="(item, index) in data_list.gywm_tp" :key="index" >
                                <img style="width: 4rem; height: 5.7rem;" :src="item.format_img">
                            </div>
                        </div>
                        <div ref="m2" class="flx">
                            <div style="margin: 0 0.2rem;" v-for="(item2, index2) in data_list.gywm_tp" :key="index2">
                                <img style="width: 4rem; height: 5.7rem ;" :src="item2.format_img">
                            </div>
                        </div>
                    </div>
                    <div class="flx jcc" style="margin-top: 0.2rem;">
                        <el-button @click="toPages('index7', '关于我们')" type="danger" size="small" plain>了解更多</el-button>
                    </div>
                </div>
            </transition>
        </div>

        <div style="padding: 0 0.3rem; height: 19rem;" ref="dom2">
            <transition name="el-zoom-in-center">
                <div v-show="dom2_show">
                    <div class="tc">
                        <b style="font-size: 0.48rem;">专家委员会</b>
                    </div>
                    <p style="font-size: 0.32rem; margin: 0.1rem auto 0 auto; line-height: 0.5rem; letter-spacing: 1px;" class="tc">{{data_list.dkyj_js}}</p>
                    <div class="flx fww jcsb" v-if="data_list.dkyj_all">
                        <div style="width: 4.5rem; height: 6.75rem; margin-top: 0.3rem;" class="pr" v-for="(item, index) in filterdkyj" :key="index" @click="toPages2('bigshotinfo2', item.id)">
                            <img style="width: 4.5rem; height: 6.75rem;" :src="item.format_img" alt="">
                            <div class="pa flx fdc jcc" style="width: 3.9rem; height: 2.8rem; background-color: rgba(125,125,125,0.5); bottom: 1rem; padding: 0 0.3rem;">
                                <div class="clf tc" style="font-size: 0.32rem;">{{item.name}}</div>
                                <span class="clf dv3 dddddff" style="font-size: 0.3rem; line-height: 0.5rem; letter-spacing: 1px; margin-top: 0.1rem;" v-html="item.image_content"></span>
                            </div>
                        </div>
                    </div>
                    <div class="flx jcc">
                        <el-button style="margin-top: 0.8rem;" @click="toPages('bigshotlist2', '专家委员会')" type="danger" size="small" plain>了解更多</el-button>
                    </div>
                </div>
            </transition>
        </div>

        <el-carousel :interval="5000" indicator-position="none" height="2.63rem" v-if="data_list.zjjs_tp && data_list.zjjs_tp.length > 0" style="margin-bottom: 1rem;">
            <el-carousel-item v-for="(item, index) in data_list.zjjs_tp" :key="index">
                <img :src="item.format_img" style="width: 100%; height: 100%;" alt="" @click="openweb(item.image_url)">
            </el-carousel-item>
        </el-carousel>

        <div style="padding: 0 0.3rem; height: 12.8rem;" ref="dom3">
            <transition name="el-zoom-in-center">
                <div v-show="dom3_show">
                    <div class="flx jcc">
                        <b style="font-size: 0.48rem;">合作领域</b>
                    </div>
                    <div class="flx fww jcsb" v-if="data_list.hzhb_tp">
                        <img class="shouxing" style="width: 4.5rem; height: 4.5rem; margin-top: 0.3rem;" v-for="(item, index) in filterhzly" :key="index" :src="item.format_img" alt="" @click="toPages2('allstore2', item.id)">
                    </div>
                    <div class="flx jcc">
                        <el-button style="margin-top: 0.8rem;" @click="toPages('index8', '合作伙伴')" type="danger" size="small" plain>了解更多</el-button>
                    </div>
                </div>
            </transition>
        </div>

        <div style="padding: 0 0.3rem; margin-bottom: 0.8rem;" ref="dom4">
            <transition name="el-zoom-in-center">
                <div v-show="dom4_show">
                    <div class="tc">
                        <b style="font-size: 0.48rem;">最新资讯</b>
                    </div>
                    <div style="margin-top: 0.3rem;">
                        <img v-for="(item, index) in data_list.xwzx_tp" :key="index" style="width: 9.4rem; height: 5.57rem;" :src="item.format_img" alt="" @click="openweb(item.image_url)">
                    </div>

                    <div>
                        <div v-for="(item, index) in data_list.xwzx_xw" :key="index" class="flx" style="border-bottom: 1px solid #eee; padding: 0.3rem 0;" @click="toPages2('articledetails2', item.article_id)">
                            <div style="color: #626971; width: 2.2rem; margin-top: 0.1rem;" class="flx fdc">
                                <span style="font-size: 0.56rem;">{{item.article_date}}</span>
                                <span style="font-size: 0.3rem; margin-top: 0.1rem;" class="mt5">{{item.article_year}}</span>
                            </div>
                            <div style="width: 7rem;">
                                <div style="font-size: 0.38rem; width: 7rem; text-align: left;" class="dffaaa dv1">{{item.article_title}}</div>
                                <p class="dv2 flx" style="color: #878787; line-height: 0.5rem; font-size: 0.34rem; margin: 0.3rem 0 0 0; text-align: left;" v-html="item.article_content"></p>
                            </div>
                        </div>
                    </div>
                    <div class="flx jcc">
                        <el-button style="margin-top: 0.8rem;" @click="toPages('index9', '最新资讯')" type="danger" size="small" plain>了解更多</el-button>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IndexPage',
    data () {
        return {
            setInter: '',
            data_list: '',
            dom1_show: false,
            dom2_show: false,
            dom3_show: false,
            dom4_show: false
        }
    },
    computed: {
        filterdkyj() {
            return this.data_list.dkyj_all.filter((val, i) => {
                return i < 4
            })
        },
        filterhzly() {
            return this.data_list.hzhb_tp.filter((val, i) => {
                return i < 4
            })
        },
    },
    methods: {
        scrollHandle() {
            if (this.$refs.dom1.getBoundingClientRect().top <= window.innerHeight && this.$refs.dom1.getBoundingClientRect().bottom >= 0) {
                this.dom1_show = true
            }
            if (this.$refs.dom2.getBoundingClientRect().top <= window.innerHeight && this.$refs.dom2.getBoundingClientRect().bottom >= 0) {
                this.dom2_show = true
            }
            if (this.$refs.dom3.getBoundingClientRect().top <= window.innerHeight && this.$refs.dom3.getBoundingClientRect().bottom >= 0) {
                this.dom3_show = true
            }
            if (this.$refs.dom4.getBoundingClientRect().top <= window.innerHeight && this.$refs.dom4.getBoundingClientRect().bottom >= 0) {
                this.dom4_show = true
            }
        },
        getData() {
            this.$post('index.php?s=/api/index/index', {
                wxapp_id: 10001
            })
            .then((res) => {
                if(res.code == 1) {
                    var a_data = res.data.list;
                    for (let i = 0; i < a_data.xwzx_xw.length; i++) {
                        a_data.xwzx_xw[i].article_content = this.showHtml(a_data.xwzx_xw[i].article_content);
                        a_data.xwzx_xw[i].article_content = a_data.xwzx_xw[i].article_content.replace(/<\/?br[^>]*>/gi,'')
                    }
                    for (let i = 0; i < a_data.dkyj_all.length; i++) {
                        if(a_data.dkyj_all[i].image_content) {
                            a_data.dkyj_all[i].image_content = this.showHtml(a_data.dkyj_all[i].image_content);
                            a_data.dkyj_all[i].image_content = a_data.dkyj_all[i].image_content.replace(/<\/?br[^>]*>/gi,'')
                        }
                    }
                    this.data_list = a_data;
                }
            }) 
        },
        showHtml(str){
            return str
            .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g,"<")
            .replace(/&gt;/g,">")
            .replace(/&quot;/g,"\"")
            .replace(/&#39;/g, "\"")
            .replace(/<\/?p[^>]*>/gi,'')
            .replace(/<\/?hr[^>]*>/gi,'')
            .replace(/<\/?img[^>]*>/gi,'')
            .replace(/&amp;nbsp;/g,'\u3000')
        },

        Marquee() {
            this.$nextTick(() => {
                if(this.$refs.init.scrollLeft >= this.$refs.m1.offsetWidth) {
                    this.$refs.init.scrollLeft = 0
                } else {
                    this.$refs.init.scrollLeft ++
                }
            })
        },
        
        toPages(page, parameter) {
            this.$router.push({
                path: '/' + page,
                query: {
                    name: parameter
                }
            })
        },

        toPages2(page, parameter) {
            this.$router.push({
                path: '/' + page,
                query: {
                    id: parameter
                }
            })
        },

        openweb(e) {
            if(e) {
                var aa = e.split('?');
                aa[0] = aa[0] + 2;
                var bb = aa.join('?');
                window.open(bb)
            }
        },
    },
    created() {
        var data = this.$route.query;
        if(data.name) {
            document.title = data.name;
        } else {
            document.title = '首页';
        }
        this.getData();
    },
    mounted() {
        var that = this;
        this.setInter = setInterval(function() {
            that.Marquee();
        }, 20);
        this.scrollHandle();
        window.addEventListener("scroll", this.scrollHandle);
	},
    destroyed() {
        clearInterval(this.setInter)
        window.removeEventListener("scroll", this.scrollHandle)
    }

}
</script>

<style scoped>
    .dddddff >>> p {
        margin: 0;
    }
    .dffaaa{
        color: #333;
    }
</style>



// WEBPACK FOOTER //
// src/components/index2/index6.vue